import { createContext, useContext } from "react";
import { ReleaseReport, ReviewRecord } from "@design-controls/types";

export type ReviewTabContextValue = {
  data: ReviewRecord;
  canApprove: boolean;
  reportData?: ReleaseReport;
  isComplete: boolean;
  isLoading: boolean;
  hasOutdatedDesignElements?: boolean;
};

export const ReviewTabContext = createContext<
  ReviewTabContextValue | undefined
>(undefined);

export const useReviewTabContext = (): ReviewTabContextValue => {
  const context = useContext(ReviewTabContext);
  if (!context) {
    throw new Error("useReviewTabContext must be used within ReviewOverview");
  }
  return context;
};
